<app-website-header [customerContent]="customerContent"></app-website-header>
<div class="container-fluid p-0 mb-5" id="home">
  <div id="header-carousel" class="carousel slide">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img
          class="w-100 img-fluid"
          src="assets/img/MYKADAI-BANNER.jpg"
          alt="Image"
        />
      </div>
    </div>
  </div>
</div>

<app-customer *ngIf="customerContent"></app-customer>
<app-website-shop *ngIf="!customerContent"></app-website-shop>

<footer class="bg-dark text-light py-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 mb-4 mb-lg-0">
        <h5 class="text-uppercase mb-4">My Kadai</h5>
        <p class="small text-white">
          Your trendsetting destination for easy shopping and service ordering.
          Experience the convenience of a single app for all your needs.
        </p>
        <a
          [routerLink]="['/privacy-policy']"
          class="text-decoration-none text-white"
          >Terms and Condition & Privacy Policy</a
        >
        <!--<div class="social-links mt-3">
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                            class="fab fa-facebook-f"></i></a>
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                            class="fab fa-twitter"></i></a>
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i class="fab fa-instagram"></i></a>
                    <a href="#" class="btn btn-outline-light btn-social rounded-circle"><i
                            class="fab fa-linkedin-in"></i></a>
                </div>-->
      </div>
      <!-- <div class="col-lg-4 mb-4 mb-lg-0"> -->
      <!--<h5 class="text-uppercase mb-4">Quick Links</h5>
                <ul class="list-unstyled">
                    <li class="mb-2"><a href="#" class="text-muted">Home</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">Shop</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">Services</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">About Us</a></li>
                    <li class="mb-2"><a href="#" class="text-muted">Contact</a></li>
                </ul>-->
      <!-- </div> -->
      <div class="col-lg-4 mb-4 mb-lg-0">
        <h5 class="text-uppercase mb-4">user manual</h5>
        <a (click)="openManualFor()" class="text-white" role="button"
          >click here to see<img
            src="assets/img/manual/images.png"
            alt="User Manual"
            class="img-fluid ms-3 manual-img"
        /></a>
      </div>
      <div class="col-lg-4">
        <h5 class="text-uppercase mb-4">Contact Us</h5>
        <p class="small text-white mb-2">
          <i class="fas fa-map-marker-alt mr-2"></i>
          <a
            href="https://www.google.com/maps?q=20/26,+Subbiah+colony,+K+K+Nagar,+Madurai"
            target="_blank"
            class="text-white text-decoration-none"
          >
            26/20, Subbiah colony, K K Nagar, Madurai - 625 020
          </a>
        </p>
        <p class="small text-white mb-2">
          <i class="fas fa-envelope mr-2"></i>
          <a
            href="mailto:support@mykadai.com"
            class="text-white text-decoration-none"
          >
            support&#64;mykadai.com
          </a>
        </p>
        <p class="small text-white mb-2">
          <i class="fas fa-phone mr-2"></i>
          <a href="tel:9787738282" class="text-white text-decoration-none">
            9787738282
          </a>
        </p>
        <div class="mt-3">
          <a
            href="https://play.google.com/store/apps/details?id=cloud.varnik.mykadai&pcampaignid=web_share"
            target="_blank"
            class="btn btn-sm btn-outline-light"
          >
            <i class="fab fa-google-play fa-lg mr-2"></i>
            <span>Google Play</span>
          </a>
          <a href="#" class="btn btn-sm btn-outline-light ml-2">
            <i class="fab fa-apple fa-lg mr-2"></i>
            <span>App Store</span>
          </a>
        </div>
      </div>
    </div>
    <hr class="my-4 border-secondary" />
    <div class="row">
      <div class="col-md-6 text-center text-md-left">
        <p class="small text-white mb-0">
          &copy; {{ currentYear }} My Kadai. All rights reserved.
        </p>
      </div>
      <div class="col-md-6 text-center text-md-right">
        <p class="small text-white mb-0">
          Designed & Developed by
          <a
            href="https://varnik.cloud/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-white"
            style="margin: 0"
          >
            VarNik.Cloud</a
          >
        </p>
      </div>
    </div>
  </div>
</footer>

<!-- Role Modal -->
<div
  [style.display]="isOpen ? 'block' : 'none'"
  class="modal modal-bg px-md-0 px-2"
  tabindex="-1"
  id="roleModal"
  aria-labelledby="roleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-4 shadow-lg">
      <div class="modal-header border-0">
        <h5
          class="modal-title w-100 text-center cabin-bold"
          id="roleModalLabel"
        >
          Are you
        </h5>
      </div>
      <div
        class="modal-body text-center d-flex justify-content-around align-items-center px-4 pb-4"
      >
        <div
          class="role-card text-center"
          (click)="customerType('Shop Owner')"
          type="button"
        >
          <div class="img-bg">
            <img
              src="assets/img/icons/owner.png"
              class="img-fluid"
              alt="shop-owner"
            />
          </div>
          <h6 class="fw-bold mt-2">Shop Owner</h6>
        </div>
        <div
          class="role-card text-center"
          (click)="customerType('Customer')"
          type="button"
        >
          <div class="img-bg">
            <img
              src="assets/img/icons/team.png"
              class="img-fluid"
              alt="customer"
            />
          </div>
          <h6 class="fw-bold mt-2">Customer</h6>
        </div>
      </div>
    </div>
  </div>
</div>
